import axios from './axiosClient';
import { getToken } from '../utils/jwt-helper';

/**
 * Registers global axios debug logging (token snapshot before each request; full error payloads).
 * Side effect only — no request/response mutation.
 */
function buildTokenLogPayload() {
  const token = getToken();
  const s = token != null ? String(token) : '';
  const base = {
    storedTokenPresent: Boolean(s.trim()),
    storedTokenLength: s.length,
    authorizationHeaderWouldBeEmpty: !s.trim(),
  };
  if (process.env.NODE_ENV === 'development') {
    return { ...base, token: s || null };
  }
  return {
    ...base,
    tokenPreview: s ? `${s.slice(0, 12)}…` : null,
  };
}

export function logTokenBeforeRequest(tag, extra = {}) {
  console.debug('[API:token]', { tag, ...buildTokenLogPayload(), ...extra });
}

export function logAdminHttpClientError(tag, error) {
  console.error('[API:admin-fetch:error]', {
    tag,
    status: error?.status,
    body: error?.body,
    message: error?.message,
    name: error?.name,
    stack: error?.stack,
    fullError: error,
  });
}

// Only register noisy interceptors in development
if (process.env.NODE_ENV !== 'production') {
  axios.interceptors.request.use((config) => {
    const authHeader =
      config.headers?.Authorization ??
      config.headers?.authorization ??
      config.headers?.common?.Authorization;
    console.debug('[API:axios:request]', {
      url: config.url,
      method: (config.method || 'get').toUpperCase(),
      ...buildTokenLogPayload(),
      authorizationOnConfig: Boolean(authHeader),
    });
    return config;
  });

  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      const res = err.response;
      console.error('[API:axios:error]', {
        message: err.message,
        code: err.code,
        name: err.name,
        requestUrl: err.config?.url,
        requestMethod: err.config?.method,
        responseStatus: res?.status,
        responseStatusText: res?.statusText,
        responseData: res?.data,
        responseHeaders: res?.headers ? { ...res.headers } : undefined,
      });
      return Promise.reject(err);
    }
  );
}
